"use client"

import { useTranslations, useLocale } from 'next-intl'
import { Link } from "@/i18n/navigation"
import { 
  Hotel, 
  UtensilsCrossed, 
  Calendar, 
  PartyPopper, 
  MapPin, 
  Camera, 
  Plane, 
  Building2,
  TreePine,
  Compass,
  Users,
} from "lucide-react"
import HeaderPage from './header-page'

const services = [
  {
    id: 1,
    titleKey: "navigation.hotels",
    descriptionKey: "sections.luxuryHotels",
    icon: Hotel,
    link: "/hotels",
    color: "bg-blue-500"
  },
  {
    id: 2,
    titleKey: "navigation.restaurants", 
    descriptionKey: "sections.authenticCuisine",
    icon: UtensilsCrossed,
    link: "/restaurants",
    color: "bg-orange-500"
  },
  {
    id: 3,
    titleKey: "navigation.events",
    descriptionKey: "sections.upcomingEvents", 
    icon: Calendar,
    link: "/events",
    color: "bg-purple-500"
  },
  {
    id: 4,
    titleKey: "navigation.festivals",
    descriptionKey: "sections.culturalFestivals",
    icon: PartyPopper,
    link: "/festivals", 
    color: "bg-pink-500"
  },
  {
    id: 5,
    titleKey: "navigation.destinations",
    descriptionKey: "sections.popularDestinations",
    icon: MapPin,
    link: "/destinations",
    color: "bg-green-500"
  },
  {
    id: 6,
    titleKey: "navigation.activities",
    descriptionKey: "sections.adventureActivities",
    icon: Compass,
    link: "/activities",
    color: "bg-red-500"
  },
  {
    id: 7,
    titleKey: "navigation.museums",
    descriptionKey: "sections.culturalMuseums",
    icon: Building2,
    link: "/museums",
    color: "bg-indigo-500"
  },
  {
    id: 8,
    titleKey: "navigation.monuments",
    descriptionKey: "sections.historicalSites",
    icon: Camera,
    link: "/monuments",
    color: "bg-yellow-500"
  },
  {
    id: 9,
    titleKey: "navigation.circuits",
    descriptionKey: "sections.guidedTours",
    icon: Plane,
    link: "/circuits",
    color: "bg-teal-500"
  },
  {
    id: 10,
    titleKey: "navigation.states",
    descriptionKey: "sections.exploreRegions",
    icon: TreePine,
    link: "/states",
    color: "bg-emerald-500"
  },
  {
    id: 11,
    titleKey: "navigation.guestHouses",
    descriptionKey: "sections.localStays",
    icon: Building2,
    link: "/guest-houses",
    color: "bg-cyan-500"
  },
  {
    id: 12,
    titleKey: "navigation.medicalStays",
    descriptionKey: "sections.wellnessTreatments",
    icon: Users,
    link: "/medical-stays",
    color: "bg-rose-500"
  },
]

export default function ServicesClient() {
  const t = useTranslations()
  const locale = useLocale()

  return (
    <div className="min-h-screen" dir={locale === 'ar' ? 'rtl' : 'ltr'}>
      <HeaderPage
              title={t('common.services')}
              breadcrumbs={[
                { label: t('common.home'), href: "/" },
                { label: t('common.services'), href: "/services" },
              ]}
      />
      {/* Services Grid */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {services.map((service) => {
            const IconComponent = service.icon
            return (
              <Link
                key={service.id}
                href={service.link}
                className="group bg-card rounded-xl p-6 border border-border hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
              >
                <div className={`w-12 h-12 ${service.color} rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}>
                  <IconComponent className="w-6 h-6 text-white" />
                </div>
                
                <h3 className="text-lg font-semibold text-foreground mb-2 group-hover:text-primary transition-colors">
                  {t(service.titleKey)}
                </h3>
                
                <p className="text-sm text-muted-foreground line-clamp-3">
                  {t(service.descriptionKey)}
                </p>
                
                <div className="mt-4 flex items-center text-primary text-sm font-medium">
                  <span>{t('common.viewAll')}</span>
                  <svg 
                    className={`w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform ${locale === 'ar' ? 'rotate-180 group-hover:-translate-x-1' : ''}`} 
                    fill="none" 
                    viewBox="0 0 24 24" 
                    stroke="currentColor"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                  </svg>
                </div>
              </Link>
            )
          })}
        </div>
      </div>
    </div>
  )
}